import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmpresaService } from '../services/empresaService';

const EmpresaCreate: React.FC = () => {
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    const empresa = { nome, cnpj, email, telefone };
    const validation = EmpresaService.validateEmpresa(empresa);
    if (!validation.isValid) {
      setError(validation.errors.join('\n'));
      return;
    }

    try {
      setLoading(true);
      await EmpresaService.create(empresa as any);
  // Após criar, ir para dashboard
  navigate('/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao criar empresa');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-6 rounded shadow">
        <h2 className="text-2xl font-bold">Cadastrar Empresa</h2>
        {error && (
          <div className="p-3 bg-red-50 text-red-700 rounded">{error}</div>
        )}
        <form className="space-y-2" onSubmit={handleSubmit}>
          <input required placeholder="Nome" value={nome} onChange={(e) => setNome(e.target.value)} className="w-full px-3 py-2 border rounded" />
          <input required placeholder="CNPJ" value={cnpj} onChange={(e) => setCnpj(e.target.value)} className="w-full px-3 py-2 border rounded" />
          <input required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-3 py-2 border rounded" />
          <input placeholder="Telefone" value={telefone} onChange={(e) => setTelefone(e.target.value)} className="w-full px-3 py-2 border rounded" />

          <div className="flex space-x-2">
            <button type="submit" disabled={loading} className="px-2 py-1 bg-indigo-600 text-white rounded disabled:opacity-50">
              {loading ? 'Salvando...' : 'Criar'}
            </button>
            <button type="button" onClick={() => navigate('/')} className="px-2 py-1 bg-gray-200 rounded">
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmpresaCreate;
